/* eslint-disable */
import { contactsImage } from './images'

export const theLightTheme = {
    type: 'light',
    primary: '#228B22',
    quaternary: '#F0F8F0',
    quaternaryLight: '#F7FBF7',
    secondary: '#ffffff',
    tertiary: '#0f1419',
    buttonColor: '#0F1419',
    contactsimg: contactsImage
}

export const theDarkTheme = {
    type: 'dark',
    primary: '#32CD32',
    secondary: '#1A2F1A',
    quaternary: '#0D1F0D',
    quaternaryLight: '#8b98a5',
    tertiary: '#EFF3F4',
    buttonColor: '#8B98A5',
    contactsimg: contactsImage
}
